import { Directive, HostBinding, Input } from '@angular/core';

import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Directive({
  selector: '[snDrawerContent], sn-drawer-content',
  host: {
    class: 'sn-drawer__content',
  },
})
export class SnDrawerContentDirective {
  @Input()
  @HostBinding('class.sn-drawer__content--indented')
  set indented(value: boolean) {
    this._indented = coerceBooleanProperty(value);
  }
  get indented(): boolean {
    return this._indented;
  }

  private _indented: boolean;
}
